
import { LocalStorageService } from 'angular-web-storage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';
import { Component, OnInit } from '@angular/core';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { firstValueFrom } from 'rxjs';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { CompaniesService } from '../_services/companies.service';
import { CompanyCaseModeService } from '../_services/company-case-mode.service';
import { CasesModesService } from '../../cases/_services/cases-modes.service';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';

@Component({
    selector: 'app-companies-list',
    templateUrl: './companies-list.component.html',
    styleUrls: ['./companies-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class CompaniesComponent implements OnInit{
  
  public companies: any = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = this.createDefaultFilters();
  public allowDelete: boolean = false;
  public caseModes: any[] = [];
  public selectedCaseModeFilterId: string | null = null;
  public companyCaseModesByCompanyId: any = {};
  public caseModeChip: Filter = new Filter(FilterOperation.equals, 'caseModeId');
  public caseModeOptions: { label: string; value: any }[] = [];
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.caseModeChip, type: 'select', label: 'Modo de expediente', options: this.caseModeOptions, base: true }
  ];

  constructor(
    private storage: LocalStorageService,
    private messageService: MessageService,    
    private confirmationService: ConfirmationService,                
    private router: Router,
    private topbarService: TopbarService,
    private loginService: LoginService,
    private companiesService: CompaniesService,
    private companyCaseModeService: CompanyCaseModeService,
    private caseModesService: CasesModesService
  ) {
   
  }

   ngOnInit(): void {
    this.topbarService.setTitle("Compañías");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({});
    });
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");
    this.loadCaseModes();
  }

  private createDefaultFilters() {
    return {
      name: new Filter(FilterOperation.contains, 'name')
    };
  }

  async loadCaseModes() {
    let params: IParamsCollection = {
      sort: ['name']
    };

    let response = await firstValueFrom(this.caseModesService.all(params));
    this.caseModes = response.data;
    this.caseModeOptions.length = 0;
    this.caseModeOptions.push(...response.data.map((mode: any) => ({ label: mode.name, value: mode.id })));
  }

  async loadData($event: any) {

    this.lastGridEvent = $event;
    this.selectedCaseModeFilterId = this.caseModeChip.value ?? null;

    let filters: any = {
      ...this.filters
    };

    if (this.selectedCaseModeFilterId) {
      let caseModeFilters = {
        caseModeId: new Filter(FilterOperation.equals, 'caseModeId', '', this.selectedCaseModeFilterId)
      };

      let caseModeParams: IParamsCollection = {
        filter: FilterBuilder.fromObject(caseModeFilters).build(),
        page: { number: 1, size: 10000 }
      };

      let caseModeResponse = await firstValueFrom(this.companyCaseModeService.all(caseModeParams));
      let filteredCompanyIds = [...new Set(caseModeResponse.data.map((item: any) => item.companyId))];

      if (filteredCompanyIds.length === 0) {
        this.companies = [];
        this.totalRecords = 0;
        this.companyCaseModesByCompanyId = {};
        return;
      }

      filters.id = new Filter(FilterOperation.any, 'id', '', filteredCompanyIds);
    }

    let params:IParamsCollection = {      
      page: { number: $event.first+1, size: $event.rows },
      include: ['address']
    }
    
    if(typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.companiesService.all(params));
    this.companies = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
    await this.loadCompanyCaseModesForGrid();
  }

  async loadCompanyCaseModesForGrid() {
    this.companyCaseModesByCompanyId = {};
    if (!this.companies || this.companies.length === 0) {
      return;
    }

    let companyIds = this.companies.map((company: any) => company.id);
    let filters = {
      companyId: new Filter(FilterOperation.any, 'companyId', '', companyIds)
    };

    let params: IParamsCollection = {
      filter: FilterBuilder.fromObject(filters).build(),
      page: { number: 1, size: 10000 }
    };

    let response = await firstValueFrom(this.companyCaseModeService.all(params));
    let caseModeNameById = new Map(this.caseModes.map((mode: any) => [mode.id, mode.name]));

    for (const relation of response.data) {
      if (!this.companyCaseModesByCompanyId[relation.companyId]) {
        this.companyCaseModesByCompanyId[relation.companyId] = [];
      }

      let caseModeName = caseModeNameById.get(relation.caseModeId);
      if (caseModeName && !this.companyCaseModesByCompanyId[relation.companyId].includes(caseModeName)) {
        this.companyCaseModesByCompanyId[relation.companyId].push(caseModeName);
      }
    }
  }

  getCaseModesText(company: any) {
    return (this.companyCaseModesByCompanyId[company.id] || []).join(', ');
  }
  
  /*
  clearFilters() {
    this.filters = this.createDefaultFilters();
    this.selectedCaseModeFilterId = null;
    this.search();
  }
  */

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(company: any) {
    //if (this.loginService.hasPermission("COMPANIES_WRITE")) {
      this.router.navigate(['companies/' + (company && Object.keys(company).length > 0 ? company.id : 0)]);
    //}
  }

  delete(company: any) {    
    if (this.allowDelete) {      
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la compañía aseguradora?",
        header: "Eliminar compañía aseguradora",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.companiesService.delete(company.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Compañía aseguradora eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }
}
